export default "__VITE_ASSET__BCWUnALz__"